import {
  actions,
  getMyCurrentProgressesAsync,
  addSessionEventAsync,
  getMyContentProgressAsync,
  getMyContentProgressesAsync,
  markcontentAsCompletedAsync,
  getMyCurrentStartedProgressesAsync,
  getMyCurrentCompletedProgressesAsync,
  getMyCurrentFollowedProgressesAsync,
  getContinueListeningProgressesAsync,
} from './slices';

export const SessionActions = {
  ...actions,
  getMyCurrentProgressesAsync,
  addSessionEventAsync,
  getMyContentProgressAsync,
  getMyContentProgressesAsync,
  markcontentAsCompletedAsync,
  getMyCurrentStartedProgressesAsync,
  getMyCurrentCompletedProgressesAsync,
  getMyCurrentFollowedProgressesAsync,
  getContinueListeningProgressesAsync,
};
